export default __webpack_public_path__ + "static/media/fund_transaction.d817e8fa.png";